var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BaseModal", {
    attrs: {
      id: _vm.id,
      modalClass: "modal-sm",
      showCloseButton: true,
      showFooter: false,
      headerText: _vm.$t("apps.payment.message.paywithpromptpay")
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function() {
          return [
            _c("div", { staticClass: "wrapper" }, [
              _c("img", { attrs: { src: _vm.qrCodeUri } }),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "apps.payment.message.pleasewaitforamomentafterfinishedthepayment"
                      )
                    ) +
                    "\n      "
                )
              ])
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a6a4c0b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a6a4c0b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseModalScanPayment.vue
// module id = null
// module chunks = 